import { uri } from '../../api-endpoint';
import {
  IUserAPIValidationError,
  IUserFromAPISuccessResponse
} from '../../type-conversion/user/from-api-response';
import { UserAPIRequestBody } from '../../type-conversion/user/to-api-request-body';
import { createTemplateFn } from '../common';

export const createUser = (token: string) =>
  createTemplateFn(
    token,
    uri.accountList(),
    UserAPIRequestBody,
    IUserFromAPISuccessResponse,
    IUserAPIValidationError
  );
